import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ADMIN_NAV = [
  { key: 'admin-dashboard', path: '/admin-dashboard', label: 'Admin Dashboard' },
  { key: 'manage-users', path: '/manage-users', label: 'Manage Users' },
  { key: 'account-requests', path: '/account-requests', label: 'Account Requests' },
  { key: 'aircraft-admin', path: '/aircraft-admin', label: 'Manage Aircraft' },
  { key: 'ampt-admin', path: '/ampt-admin', label: 'AMPT Admin' },
  { key: 'adsb-admin', path: '/adsb-admin', label: 'ADSB Admin' },
  { key: 'historical-cdrls', path: '/historical-cdrls', label: 'Historical CDRLs' },
  { key: 'upload-checklist', path: '/upload-checklist', label: 'Upload Checklist' },
];

const ADMIN_PATHS = ADMIN_NAV.map((item) => item.path);

/**
 * Expandable hamburger submenu for staff-only admin pages.
 */
function AdminSubmenu({ theme }) {
  const location = useLocation();
  const navigate = useNavigate();
  const onAdminRoute = ADMIN_PATHS.some((path) => location.pathname === path);
  const [open, setOpen] = useState(onAdminRoute);
  const isDark = theme === 'dark';

  useEffect(() => {
    if (onAdminRoute) {
      setOpen(true);
    }
  }, [onAdminRoute]);

  const styles = {
    toggle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      padding: '12px 20px',
      color: isDark ? '#e0e0e0' : '#333',
      border: 'none',
      backgroundColor: onAdminRoute
        ? isDark
          ? 'rgba(255,255,255,0.06)'
          : 'rgba(0,0,0,0.04)'
        : 'transparent',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 600,
    },
    caret: {
      fontSize: '11px',
      opacity: 0.75,
      flexShrink: 0,
    },
    childList: {
      padding: '0 0 4px',
      backgroundColor: isDark ? 'rgba(0,0,0,0.18)' : 'rgba(0,0,0,0.03)',
    },
    childItem: {
      display: 'block',
      padding: '10px 20px 10px 32px',
      color: isDark ? '#e0e0e0' : '#333',
      border: 'none',
      backgroundColor: 'transparent',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '13px',
    },
  };

  const children = ADMIN_NAV.filter((item) => location.pathname !== item.path);

  if (children.length === 0) {
    return null;
  }

  return (
    <div>
      <button
        type="button"
        style={styles.toggle}
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>Admin</span>
        <span style={styles.caret}>{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <div style={styles.childList} role="group" aria-label="Admin">
          {children.map((item) => (
            <button
              key={item.key}
              type="button"
              style={styles.childItem}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminSubmenu;
